'use client'

import { useState } from 'react'
import { getClassNames } from '@helpers/productWidgetHelper'
import Link from 'next/link'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { CAR_COMPARISON_WIDGET_ID, commonEvents, notListed, redirectUrl } from '@constants/carComparison'
import { convertToSlug } from '@utils/IdGenerator'
import Image from 'next/image'
import CompareCard from './CompareCard'
import styles from './CarBrandInsuranceComparison.module.scss'

const CarBrandInsuranceComparison = ({ data }) => {
  const {
    data: {
      Content: { data: brands },
      label,
      title,
    },
  } = data
  const [selectedBrandIndex, setSelectedBrandIndex] = useState(0)
  const handleClick = () => {
    void trackEvent('tap_btn_CTA_widget', {
      ...{ commonEvents },
      journey: 'car_not_found',
      cta_text: 'enter car details',
    })
  }
  const switchToTab = tabIndex => {
    setSelectedBrandIndex(tabIndex)
    void trackEvent('tap_btn_CTA_widget', {
      ...{ commonEvents },
      journey: brands[tabIndex]?.attributes?.brandName,
      cta_text: brands[tabIndex]?.attributes?.brandName,
    })
  }
  return (
    <div className={styles.container} id={convertToSlug(brands[0]?.attributes?.headerTabName)}>
      <div className={styles.headingContainer} id={CAR_COMPARISON_WIDGET_ID}>
        <p className={styles.label}>{label}</p>
        <p className={styles.heading}>{title}</p>
      </div>
      <div className={styles.brandsContainer}>
        <div className={styles.brands}>
          {brands.map((brand, index) => (
            <div
              className={getClassNames([styles.brandName], {
                [styles.selected]: index === selectedBrandIndex,
              })}
              key={index}
              onClick={() => {
                switchToTab(index)
              }}>
              <Image
                src={brand?.attributes?.brandLogo?.data?.attributes?.url}
                alt={`${brand?.attributes?.brandName}-logo`}
                height={32}
                width={32}
              />
              <p>{brand?.attributes?.brandName}</p>
            </div>
          ))}
        </div>

        <div id={brands[selectedBrandIndex]?.attributes?.brandName} className={styles.brandCars}>
          {brands[selectedBrandIndex]?.attributes?.cars.map((car, index) => (
            <CompareCard data={car} brandName={brands[selectedBrandIndex]?.attributes?.brandName} key={index} />
          ))}
        </div>

        <div className={styles.notListed}>
          <div className={styles.notListedContent}>
            <Image src={notListed.icon} alt="question-icon" height={80} width={80} />
            <p className={styles.notListedTitle}>{notListed.title}</p>
            <p className={styles.notListedSubTitle}>{notListed.subTitle}</p>
          </div>
          <Link href={redirectUrl} onClick={handleClick} className={styles.notListedCta}>
            {notListed.cta}
          </Link>
        </div>
      </div>
    </div>
  )
}

export default CarBrandInsuranceComparison
